// ConfirmModal.js
import React from "react";
import { Modal, Button, Spinner } from "react-bootstrap";
import cross from "../../assets/images/icon/cross.svg";

function ConfirmModal({
  show,
  handleClose,
  handleConfirm,
  message,
  isLoading,
}) {
  return (
    <div className="edit-modal">
      <Modal show={show} onHide={handleClose} className="edit-modal-card">
        {/* <Modal.Header closeButton>
          <Modal.Title>Confirmation</Modal.Title>
        </Modal.Header> */}
        <Modal.Body>
          <div className="filters-cards-cross">
            <div className="filter-content">
              <h4></h4>
            </div>
            <div className="filter-content cross" onClick={handleClose}>
              <img src={cross} alt="" />
            </div>
          </div>

          <div className="form-modal">
            <p>{message}</p>
          </div>

          <div className="serach-btn modal-action-btn text-center mt-2  d-flex gap-3 cta ">
            <Button
              variant="secondary"
              className="btn btn-secondary btn btn-secondary"
              onClick={handleClose}
            >
              No
            </Button>
            <Button
              variant="primary"
              onClick={handleConfirm}
              disabled={isLoading}
              className="btn btn-primary"
            >
              {isLoading ? "Processing..." : "Yes"}
            </Button>
          </div>
        </Modal.Body>
        {/* <Modal.Footer className="justify-co"></Modal.Footer> */}
      </Modal>
    </div>
  );
}

export default ConfirmModal;
